// extracted by mini-css-extract-plugin
export default {"form":"ClientCreateContainer_form__EEDnp"};